var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "SelectView u-InputMarginView",
      class: [
        _vm.modes.map((m) => `SelectView--${m}`),
        { "u-ErrorView": _vm.hasError },
      ],
    },
    [
      !!_vm.title
        ? _c("label", { staticClass: "SelectViewLabel" }, [
            _vm._v(_vm._s(_vm.title)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("v-select", {
        ref: "select",
        staticClass: "SelectViewInput",
        class: { "SelectViewInput--error": _vm.isError },
        attrs: {
          value: _vm.selected,
          options: _vm.options,
          placeholder: _vm.placeholder,
          "max-height": _vm.maxHeight,
          clearable: _vm.clearable,
          searchable: _vm.searchable,
          multiple: _vm.multiple,
          filterBy: _vm.filterBy,
          label: "id",
        },
        on: { input: _vm.input },
        scopedSlots: _vm._u([
          {
            key: "option",
            fn: function (option) {
              return [
                _vm.lang !== ""
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "SelectViewOption SelectViewOption--selected",
                      },
                      [
                        _vm.isImage && option.translations[_vm.lang].image
                          ? _c("img", {
                              staticClass: "SelectViewOptionImage",
                              attrs: {
                                src: option.translations[_vm.lang].image
                                  .w100Url,
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isImage && !option.translations[_vm.lang].image
                          ? _c("div", { staticClass: "SelectViewOptionImage" })
                          : _vm._e(),
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.isSpecialist
                                ? `${option.translations[_vm.lang].title} ${
                                    option.translations[_vm.lang].surname
                                  }`
                                : option.translations[_vm.lang].title
                            ) +
                            "\n            "
                        ),
                      ]
                    )
                  : _c(
                      "span",
                      {
                        staticClass:
                          "SelectViewOption SelectViewOption--selected",
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(option.title) +
                            "\n            "
                        ),
                      ]
                    ),
              ]
            },
          },
          {
            key: "selected-option",
            fn: function (option) {
              return [
                option.id && _vm.lang !== ""
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "SelectViewOption SelectViewOption--option",
                      },
                      [
                        _vm.isImage && option.translations[_vm.lang].image
                          ? _c("img", {
                              staticClass: "SelectViewOptionImage",
                              attrs: {
                                src: option.translations[_vm.lang].image
                                  .w100Url,
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isImage && !option.translations[_vm.lang].image
                          ? _c("div", { staticClass: "SelectViewOptionImage" })
                          : _vm._e(),
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.isSpecialist
                                ? `${option.translations[_vm.lang].title} ${
                                    option.translations[_vm.lang].surname
                                  }`
                                : option.translations[_vm.lang].title
                            ) +
                            "\n            "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                option.id && _vm.lang === ""
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "SelectViewOption SelectViewOption--option",
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(option.id) +
                            "\n            "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !option.id && !_vm.isOpenMenu && _vm.searchValue.length === 0
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "SelectViewOption SelectViewOption--option",
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.placeholder) +
                            "\n            "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("svg-view", {
        class: { open: _vm.isOpenMenu },
        attrs: { name: "arrow" },
      }),
      _vm._v(" "),
      !!_vm.editOptionsTitle
        ? _c(
            "button",
            { staticClass: "SelectViewEdit", on: { click: _vm.onEditOptions } },
            [_vm._v(_vm._s(_vm.editOptionsTitle))]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }